import React from "react";
import {CouponStatus} from "../../common/constants";
import {Button} from "react-bootstrap";
import {translate} from '../../i18n/translate.js';
import style from "../../css/coupon/coupon.less";

export class Coupon extends React.Component {
    onApplyCouponClicked = () => {
        this.props.onApplyCouponClicked(this.refs.couponId.value);
    };

    render() {
        const isLoading = this.props.couponStatus === CouponStatus.VALIDATING;
        const submitLoadingClass =  isLoading? " loading" : "";
        const submitClasses = "submit-order coupon-btn button" + submitLoadingClass;
        const inputClass = this.props.invalidStatus ? "coupon-code-input coupon-code-input-error" : "coupon-code-input";
        return (<div className="optional-promotion-code">
            {translate("promotionalCode")}
            {(this.props.couponStatus === CouponStatus.VALID && !this.props.invalidStatus) ?
                <div className="coupon-code">
                    <div className="coupon-code-title">{translate("Coupon Code")}</div>
                    <div className="coupon-code-exists">{this.props.coupon.id}</div>
                    <Button bsStyle="primary" className={submitClasses}
                            onClick={this.props.removeCoupon}>{translate("Remove")}</Button>
                </div>
                :
                <div className="coupon-code">
                    <div className="coupon-code-title">Coupon Code</div>
                    <input type="text" ref="couponId" id="inpCouponCode" onChange={this.props.onChangeCouponId}
                           className={inputClass} disabled={isLoading}/>
                    <Button disabled={this.props.disabledApply || isLoading} bsStyle="primary" className={submitClasses}
                            id="btnApplyCoupon"
                            onClick={this.onApplyCouponClicked}>{translate("Apply")}</Button>
                </div>
            }
            {
                this.props.invalidStatus ?
                    <div className="coupon-code-validation">{this.props.invalidStatus}</div>
                    : undefined
            }
        </div>);
    }
}
export default Coupon;



// WEBPACK FOOTER //
// ./src/components/coupon/Coupon.js